import { render, staticRenderFns } from "./form-password.vue?vue&type=template&id=5702aff6&scoped=true"
import script from "./form-password.ts?vue&type=script&lang=ts&external"
export * from "./form-password.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702aff6",
  null
  
)

export default component.exports